import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const userWorkoutsApi = createApi({
  reducerPath: 'userWorkoutsQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['UserFavoriteWorkouts'],
  endpoints: (builder) => ({
    getUserFavoriteWorkouts: builder.query({
      query: () => ({
        url: `user-workouts-favorite`,
        method: 'GET',
      }),
      providesTags: ['UserFavoriteWorkouts'],
    }),
    addUserFavoriteWorkout: builder.mutation({
      query: (workoutId) => ({
        url: `user-workouts-favorite/${workoutId}`,
        method: 'POST',
      }),
      invalidatesTags: ['UserFavoriteWorkouts'],
    }),
    deleteUserFavoriteWorkout: builder.mutation({
      query: (id) => ({
        url: `user-workouts-favorite/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserFavoriteWorkouts'],
    }),
  }),
});

export const {
  useGetUserFavoriteWorkoutsQuery,
  useAddUserFavoriteWorkoutMutation,
  useDeleteUserFavoriteWorkoutMutation,
} = userWorkoutsApi;
